// extracted by mini-css-extract-plugin
export default {"wrapper":"RightBox_wrapper__wFY3m","top":"RightBox_top__5CDJt","center":"RightBox_center__Ip1V8","bottom":"RightBox_bottom__4wmqT"};